import { isSchoolAdminRole } from './roles';

/**
 * School onboarding gate — single source of truth shared by the post-login
 * redirect (getHomeRoute / MagicLinkCallback) and the route guard
 * (RequireSchoolSetup).
 *
 * A school admin's setup is complete when the tenant profile exists and
 * school_profile_completed is true. Falls back to deriving completeness from
 * the profile fields for stale cached sessions where the flag is not set yet.
 */
export const isSchoolSetupComplete = (user) => {
  const t = user?.tenant;
  if (!t) return false;

  const derivedComplete = Boolean(t.name && t.address && t.state && (t.phone || t.mobile_number));
  const incomplete = t.school_profile_completed === false || (t.school_profile_completed == null && !derivedComplete);

  return !incomplete;
};

/**
 * True when the user is a school administrator (or legacy tenant_admin alias)
 * and still needs to complete the school setup wizard before using the portal.
 */
export const requiresSchoolSetup = (user) => isSchoolAdminRole(user?.role) && !isSchoolSetupComplete(user);
